import { useContext, useEffect, useState } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";

import { useModal } from "../../hooks";
import { campaignService, regexService } from "../../service";
import { loaderContext, notificationContext } from "../../context/context";
import numberFormat from "../../utils/numberFormat";

import { Modal } from "../../components";
import dateFormat, { getExpiryDate } from "../../utils/dateFormat";
import { StatusChip } from "../../utils/chipUtils";
import { AdapterDayjs } from "@mui/x-date-pickers-pro/AdapterDayjs";
import {
  DatePicker,
  LocalizationProvider,
  MobileDatePicker,
} from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { useBottomScrollListener } from "react-bottom-scroll-listener";

let pagecount = 1;

let initialFilterState = {
  searchvalue: "",
  fromdate: dayjs().subtract(7, "days"),
  todate: dayjs(),
};

function InvoiceList() {
  const navigate = useNavigate();

  const [isPagination, setPagination] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [pageCount, setPageCount] = useState(1);
  const [invoiceList, setinvoiceList] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [isFilter, setFilterStatus] = useState(false);
  const [filterValue, setFilterValue] = useState(initialFilterState);

  const { isModal, showModal, hideModal } = useModal();
  const filterModal = useModal();
  const loader = useContext(loaderContext);
  const toast = useContext(notificationContext);

  const [modalData, setModalData] = useState();

  const getInvoiceList = async (actionType = "LISTING") => {
    if (pageCount == 1 && actionType == "LISTING") {
      setTotalCount(0);
      setinvoiceList([]);
    }
    const filterData = {
      searchtext: filterValue?.searchvalue || "",
      fromdate: dayjs(filterValue?.fromdate).format("YYYY-MM-DD"),
      todate: dayjs(filterValue?.todate).format("YYYY-MM-DD"),
      pagecount: pagecount,
      actiontype: actionType,
      totalcount: totalCount,
    };
    try {
      const response = await campaignService.getInvoiceList(filterData);
      if (actionType === "LISTING") {
        if (response.error) {
          throw response.error;
        }
        if (pageCount > 1) {
          setinvoiceList(invoiceList?.concat(response.data));
        } else {
          setinvoiceList(response.data || []);
          setTotalCount(response?.Totalrecord || 0);
        }
      } else {
        if (response.data) {
          toast.success(
            `Your file ${response.data.fileName} has been downloaded successfully.`
          );
        } else {
          toast.error(
            "File Download failed. Please try again after sometimes."
          );
        }
      }
    } catch (error) {
      if (error.code !== 101) {
        toast.error(error.message);
      }
      if (isPagination && actionType === "LISTING") {
        setPageCount((count) => count - 1);
      }
    } finally {
      setPagination(false);
      setIsLoading(false);
      // setinvoiceList(invoiceListData);
      loader.hideLoader();
    }
  };

  const showInvoiceData = (singleInvoiceData) => {
    setModalData(singleInvoiceData);
    showModal();
  };

  const handleDateChange = (value, filterid) => {
    if (filterid === "fromdate" && dayjs(value).isAfter(filterValue?.todate)) {
      setFilterValue({ ...filterValue, todate: value, [`${filterid}`]: value });
    } else {
      setFilterValue({ ...filterValue, [`${filterid}`]: value });
    }
  };

  const incrementPageCount = () => {
    if (totalCount > pageCount * 10 && !isPagination) {
      setPagination(true);
      setPageCount(pageCount + 1);
    }
  };

  const handleFilter = (actionType) => {
    if (actionType === "APPLY") {
      handleAPICall();
    } else if (actionType === "RESET") {
      setFilterValue({
        searchvalue: filterValue?.searchvalue || "",
        fromdate: dayjs().subtract(7, "days"),
        todate: dayjs(),
      });
      setPageCount(1);
      setIsLoading(true);
      setFilterStatus(true);
    }
    filterModal.hideModal();
  };

  const handleAPICall = () => {
    if (pageCount == 1) {
      setIsLoading(true);
      getInvoiceList();
    } else {
      setPageCount(1);
    }
  };

  useEffect(() => {
    if (filterValue?.searchvalue == "" && !isLoading) {
      handleAPICall();
    }
  }, [filterValue?.searchvalue]);

  useEffect(() => {
    pagecount = pageCount;
    if (pageCount > 1 && isPagination) {
      getInvoiceList();
    }
    if (pageCount == 1 && !isLoading) {
      setIsLoading(true);
      getInvoiceList();
    }
  }, [pageCount]);

  useEffect(() => {
    if (isFilter) {
      handleAPICall();
      setFilterStatus(false);
    }
  }, [isFilter]);

  useEffect(() => {
    getInvoiceList();
  }, []);

  const invoiceBottomListner = useBottomScrollListener(incrementPageCount, {
    offset: 30,
  });

  const outletContext = useOutletContext();

  outletContext.setBottomListnerValue(invoiceBottomListner);

  return (
    <div>
      <div className="flex-nowrap flex-center justify-content-between">
        <h5>Invoice {totalCount > 0 && `(${totalCount})`}</h5>
        <button
          className="btn--sm btn-primary"
          onClick={() => navigate("createinvoice")}
        >
          Create Invoice
        </button>
      </div>
      <div className="mt-2">
        <div className="fc-nowrap flex-center justify-content-between mt-4">
          <label className="input input--sm fc-4">
            <input
              type="text"
              id="searchvalue"
              placeholder="Search by Invoice ID"
              value={filterValue?.searchvalue || ""}
              onChange={(e) => {
                regexService.isAlphaNum(e.target.value) &&
                  setFilterValue({
                    ...filterValue,
                    searchvalue: e.target.value || "",
                  });
              }}
            />
            <button
              className="btn--xs btn-primary"
              onClick={() => {
                handleAPICall();
              }}
            >
              <span class="material-symbols-rounded">search</span>
            </button>
          </label>
          <div
            className="flex-center gap-sm cursor-pointer"
            onClick={filterModal.showModal}
          >
            <span>Filter</span>
            <div className="icon">
              <span class="material-symbols-rounded">filter_list</span>
            </div>
          </div>
        </div>
        <div className="flex justify-content-end mt-2">
          {!isLoading && invoiceList?.length > 0 && (
            <div
              className="icon"
              onClick={() => {
                loader.showLoader();
                getInvoiceList("DOWNLOAD");
              }}
            >
              <span class="material-symbols-outlined ">download</span>
            </div>
          )}
        </div>
        <div className="cover border rounded-border-sm mt-3">
          <div className="table overflow-x-auto">
            <table>
              <thead>
                <tr>
                  <th>Invoice ID</th>
                  <th>Customer Name</th>
                  <th>Amount</th>
                  <th>Created By</th>
                  <th>Created on</th>
                  <th>Status</th>
                </tr>
              </thead>
              {!isLoading && invoiceList?.length > 0 && (
                <tbody className="table-body">
                  {invoiceList?.map((data) => (
                    <tr>
                      <td
                        title={data?.invoice_no}
                        className="f-600 cursor-pointer"
                        onClick={() => showInvoiceData(data)}
                      >
                        {" "}
                        {data.invoice_no}
                      </td>
                      <td title={data?.customer_name}>{data.customer_name}</td>
                      <td title={data?.amount}>{numberFormat(data.amount)}</td>
                      <td title={data?.createdby}>{data.createdby}</td>
                      <td title={dateFormat(data?.createdt)}>
                        {dateFormat(data.createdt)}
                      </td>
                      <td title={data?.status}>
                        <StatusChip status={data?.status} />
                      </td>
                    </tr>
                  ))}
                </tbody>
              )}
            </table>
          </div>
          {((isPagination || isLoading) && (
            <div className="no-records">Loading...</div>
          )) ||
            (invoiceList?.length == 0 && (
              <div className="no-records">No Records to display</div>
            ))}
        </div>
      </div>
      {isModal && (
        <Modal>
          <div className="side-modal modal--sm">
            <div className="modal-head border-bottom">
              <div>
                <h6>Invoice Details</h6>
              </div>
              <div className="icon" onClick={hideModal}>
                <span class="material-symbols-rounded">close</span>
              </div>
            </div>
            <div className="modal-body overflow-y-auto pb-4">
              <div className="flex-center justify-content-between">
                <div className="my-2">
                  <p className="f-500 title">Invoice ID</p>
                  <h6 className="word-break-all">{modalData?.invoice_no}</h6>
                </div>
                <div className="fc-auto">
                  <StatusChip status={modalData?.status} />
                </div>
              </div>
              <div className="fc flex-wrap justify-content-between">
                <div className="input-wrapper mt-2 fc-5">
                  <p className="title">Amount</p>
                  <p>{numberFormat(modalData?.amount)}</p>
                </div>
                {modalData?.status?.toUpperCase() === "SUCCESS" && (
                  <div className="input-wrapper mt-2 fc-5">
                    <p className="title">Paid Amount</p>
                    <p>{numberFormat(modalData?.editedamount)}</p>
                  </div>
                )}
                <div className="input-wrapper mt-2 fc-5">
                  <p className="title">Editable Amount</p>
                  <p>{(modalData?.linktype === "NOT" && "No") || "Yes"}</p>
                </div>
              </div>
              <div className="input-wrapper">
                <p className="title">Purpose of Payment</p>
                <p>{modalData?.order_desc}</p>
              </div>
              <div className="fc flex-nowrap justify-content-between">
                <div className="input-wrapper fc-5">
                  <p className="title">Created on</p>
                  <p>{dateFormat(modalData?.createdt)}</p>
                </div>
                <div className="input-wrapper fc-5">
                  <p className="title">Expire at</p>
                  <p>
                    {getExpiryDate(
                      modalData?.merc_order_date,
                      modalData?.expiry_period
                    )}
                  </p>
                </div>
              </div>
              <div className="flex-nowrap justify-content-between">
                <div className="input-wrapper fc-5">
                  <p className="title">Notification Type</p>
                  <div className="flex gap-sm">
                    {modalData?.smscomm == "Y" && (
                      <StatusChip status={modalData?.smsstatus} value="SMS" />
                    )}
                    {modalData?.emailcomm == "Y" && (
                      <StatusChip status={modalData?.emailstatus} value="Email" />
                    )}
                    {modalData?.whatsappcomm == "Y" && (
                      <StatusChip status={modalData?.whatsappStatus} value="Whatsapp" />
                    )}
                  </div>
                </div>
              </div>
              {modalData?.links && (
                <div className="input-wrapper">
                  <p className="title">Payment Link</p>
                  <p className="word-break-all">{modalData?.links}</p>
                </div>
              )}

              <hr />
              <div className="flex-nowrap">
                <div className="fc flex-nowrap justify-content-between input-wrapper">
                  <div className="fc-5">
                    <p className="title">Customer Name</p>
                    <p className="word-break-all">{modalData?.customer_name}</p>
                  </div>
                  <div className="fc-5">
                    <p className="title">Customer ID</p>
                    <p className="word-break-all">{modalData?.customer_id}</p>
                  </div>
                </div>
              </div>
              <div className="fc flex-nowrap justify-content-between input-wrapper">
                <div className="fc-5">
                  <p className="title">Email</p>
                  <p>{modalData?.customer_email}</p>
                </div>
                <div className="fc-5">
                  <p className="title">Mobile No</p>
                  <p>{modalData?.customer_phone}</p>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      )}
      {filterModal?.isModal && (
        <Modal>
          <div className="modal modal--sm rounded-border-sm">
            <div className="modal-head">
              <h6 className="f-500">Filter</h6>
              <div className="list-icon" onClick={() => handleFilter("CLOSE")}>
                <span class="material-symbols-rounded">close</span>
              </div>
            </div>
            <div className="modal-body h-30 py-2">
              <p className="title">Created Date</p>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <MobileDatePicker
                  className="date-picker mr-2 mt-2"
                  label="From Date"
                  format="DD-MM-YYYY"
                  value={dayjs(filterValue?.fromdate)}
                  minDate={dayjs().subtract(6, "months")}
                  maxDate={dayjs()}
                  closeOnSelect
                  onChange={(value) => {
                    handleDateChange(value, "fromdate");
                  }}
                />
                <MobileDatePicker
                  className="date-picker mt-2"
                  label="To Date"
                  format="DD-MM-YYYY"
                  value={dayjs(filterValue?.todate)}
                  minDate={dayjs(filterValue?.fromdate)}
                  maxDate={dayjs()}
                  closeOnSelect
                  onChange={(value) => handleDateChange(value, "todate")}
                />
              </LocalizationProvider>
            </div>
            <div className="modal-foot">
              <div className="flex-center justify-content-end gap-md w-100">
                <button
                  className="btn-outline btn--sm"
                  onClick={() => handleFilter("RESET")}
                >
                  Reset
                </button>
                <button
                  className="btn-primary btn--sm"
                  onClick={() => handleFilter("APPLY")}
                >
                  Apply
                </button>
              </div>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
}

function DeliveryChip({ value, emailStatus = "0", smsStatus = "0" }) {
  if (value?.toUpperCase() === "SMS") {
    return <StatusChip status={smsStatus} value="SMS" />;
  }
  if (value?.toUpperCase() === "EMAIL") {
    return <StatusChip status={emailStatus} value="Email" />;
  }
  if (value?.toUpperCase() === "BOTH") {
    return (
      <>
        <StatusChip status={smsStatus} value="SMS" />
        <StatusChip status={emailStatus} value="Email" />
      </>
    );
  }
  return;
}

export default InvoiceList;
